import heroPosterUrl from './assets/hero-video-poster.webp?url'

import villaHomepageUrl from './assets/projects/villawhitequeen/homepage.jpeg?url'
import villaHeroVideoUrl from './assets/projects/villawhitequeen/Villa White Queen Desktop Mockup.mp4?url'
import invoroHome1Url from './assets/projects/invoro/Invoro_1_home.jpg?url'
import invoroHome2Url from './assets/projects/invoro/Invoro_2_home.jpg?url'
import invoroHome3Url from './assets/projects/invoro/Invoro_3_home.webp?url'
import invoroMobileConceptUrl from './assets/projects/invoro/invoro-mobile-concept.png?url'
import invoroDesktopMockupUrl from './assets/projects/invoro/desktop mockup.png?url'
import invoroFeaturesDesktopUrl from './assets/projects/invoro/features section invoro desktop view.png?url'
import ruciHomeUrl from './assets/projects/Ruci Foods/Ruci_home.jpg?url'
import aalsdHomeUrl from './assets/projects/AALSD/AALSD_horm.jpg?url'
import rnoneHomeUrl from './assets/projects/RNONE/RNONE_home.jpg?url'

/**
 * Preload all remaining hero images/videos for other pages in the background
 * once the main page load finishes, so navigating to them is instant.
 */
function preloadRemainingAssets() {
  if (typeof window === 'undefined') return

  const assets = [
    // Case study hero images
    villaHomepageUrl,
    invoroHome1Url,
    invoroHome2Url,
    invoroHome3Url,
    invoroMobileConceptUrl,
    invoroDesktopMockupUrl,
    invoroFeaturesDesktopUrl,
    ruciHomeUrl,
    aalsdHomeUrl,
    rnoneHomeUrl,
    'https://images.unsplash.com/photo-1542314831-068cd1dbfeeb?auto=format&fit=crop&w=1200&q=80',
    // Services / Process first images
    'https://images.unsplash.com/photo-1561070791-2526d30994b5?auto=format&fit=crop&w=900&q=80',
    'https://images.unsplash.com/photo-1522071820081-009f0129c71c?auto=format&fit=crop&w=900&q=80',
  ]

  const startPreload = () => {
    // Images
    assets.forEach(url => {
      const img = new Image()
      img.src = url
    })
  }

  if (document.readyState === 'complete') {
    if (window.requestIdleCallback) {
      window.requestIdleCallback(startPreload)
    } else {
      setTimeout(startPreload, 1500)
    }
  } else {
    window.addEventListener('load', () => {
      if (window.requestIdleCallback) {
        window.requestIdleCallback(startPreload)
      } else {
        setTimeout(startPreload, 1500)
      }
    })
  }
}

function injectHomepageGridPreloads() {
  if (typeof document === 'undefined') return

  const imagesToPreload = [
    heroPosterUrl, // Preload the actual poster image used immediately for first paint
    ruciHomeUrl,
    invoroHome1Url,
    villaHomepageUrl,
    rnoneHomeUrl,
    aalsdHomeUrl
  ]

  imagesToPreload.forEach((url, idx) => {
    const id = `preload-grid-img-${idx}`
    if (document.getElementById(id)) return

    const link = document.createElement('link')
    link.id = id
    link.rel = 'preload'
    link.as = 'image'
    link.href = url
    if (idx === 0) {
      link.fetchPriority = 'high'
      link.setAttribute('fetchpriority', 'high')
    }
    document.head.appendChild(link)
  })
}

injectHomepageGridPreloads()
preloadRemainingAssets()
